// extracted by mini-css-extract-plugin
export default {"dietaryBlock":"periodic_dietaryBlock__P5qmh"};